import React, { Component } from "react";
import CreateInitiativeSteps from './Steps';
import BreadCrumbs from './../../Drive/cards/Breadcrumbs'
import { Grid, Button, Loader } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';

import { withRouter } from 'react-router-dom';
import { dispatch } from '@rematch/core';
import { debounce } from "lodash";
import { toastr } from 'react-redux-toastr';
import _ from 'lodash';
import * as Survey from "survey-react";
import * as widgets from "surveyjs-widgets";

class ServeyMetaDataForm extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            metaDataSchema: {
                questions: []
            }
        };

        // const self = this;
        // if (self.alreadyRendered) return;
        // const script = document.createElement("script");
        // script.src = "https://cdn.ckeditor.com/4.14.1/standard/ckeditor.js";
        // document.head.append(script);

        // script.onload = function () {
        //     const CKEDITOR = window.CKEDITOR;
        //     self.alreadyRendered = true;
        //     if (self.forceUpdate) self.forceUpdate(); // need only for REACT
        // };
    }


    // onClickChild = () => {
    //     this.AddValuesToSchema.current.getAlert();
    // };

    async componentDidMount() {
        await dispatch.initiatives.getInDesignInitiativeDetailsById(this.props.match.params.initiativeId);
        dispatch.app.setRouteParams(this.props.match.params)
        dispatch.initiatives.setTabName("AddAdditionalInfo");
    }

    onComplete = async (survey, options) => {
        let obj = {}
        if (survey.data) {
            obj = survey.data
        } else {
            obj = {}
        }
        const payLoad = {
            _id: this.props.selectedDataById._id,
            metaData: obj
        }
        await dispatch.initiatives.updateInitiativeBySpecificFields(payLoad);

        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.initiatives.getInDesignInitiativeDetailsById(this.props.match.params.initiativeId);
        this.nextClick()
        dispatch.initiatives.showResourecePane(null)
    }

    next = async () => {
        // this.onComplete()
    }

    nextClick = debounce(async () => {
        const history = this.props.history;
        history.push({
            pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign/teamMapping/' + this.props.match.params.initiativeId
        });
    }, 100)

    backClick() {
        // this.AddValuesToSchema.current.updateMetaValue();
        const history = this.props.history;
        history.push({
            pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign/basicInfo/' + this.props.match.params.initiativeId
        });
        dispatch.initiatives.showResourecePane(null)
    }

    updateMetaData = async (data) => {

    }

    cancelEdit = () => {
        let message = <div className="confirmMessage">
            <h3>Cancel Editing</h3>
            <label>{this.props.selectedDataById.name}</label>
            <p>Are you sure that you want to Cancel editing this initiative?</p>
            <span >All the changes done until now will be lost.</span>
        </div>
        toastr.confirm(message, {
            okText: 'Cancel Editing',
            cancelText: 'Keep Editing',
            onOk: () => {
                dispatch.initiatives.setTabName(null);
                dispatch.app.setCollapsedResourcePaneIndexTemp(null)
                dispatch.initiatives.showResourecePane(null);
                dispatch.initiatives.cancelInitiativeEdit(this.props.selectedDataById);
            }
        });
    }

    render() {

        let jsn = {
            completeText: "Next"
        };
        if (this.props.selectedDataById &&
            this.props.selectedDataById.practiceId &&
            this.props.selectedDataById.practiceId.metaDataSchema &&
            this.props.selectedDataById.practiceId.metaDataSchema.length !== 0) {
            jsn.questions = this.props.selectedDataById.practiceId.metaDataSchema
        }
        widgets.ckeditor(Survey);
        let model = new Survey.Model(jsn);
        if (!_.isEmpty(this.props.selectedDataById.metaData)) {
            model.data = this.props.selectedDataById.metaData
        }

        return (
            <div  >
                <Form noValidate
                    ref={ref => this.form = ref}
                >
                    <Grid className="containerBoxFullWidth">
                        <Grid.Row >
                            <BreadCrumbs {...this.props} />
                        </Grid.Row>
                        <Grid.Row >
                            <CreateInitiativeSteps {...this.props} setPage="AdditionlInfo" />
                        </Grid.Row>
                        <Grid.Row >
                            <Grid className="w_100"  >
                                <Grid.Row className="configureActivity" >
                                    <Grid.Column width={16}>
                                        {this.props.selectedDataById &&
                                            this.props.selectedDataById.practiceId &&
                                            this.props.selectedDataById.practiceId.metaDataSchema &&
                                            this.props.selectedDataById.practiceId.metaDataSchema.length !== 0 ?
                                            <Survey.Survey
                                                model={model}
                                                onComplete={this.onComplete}
                                            />
                                            : <Loader active />
                                        }

                                        {this.props.selectedDataById.status === 4 && <Button
                                            style={{ margin: "15px 15px 0", float: "right" }}
                                            type="button"
                                            className="button-cancel"
                                            onClick={() => this.cancelEdit()}>Cancel </Button>}

                                        <Button
                                            style={{ margin: "15px 0 0 0" }}
                                            disabled={this.props.buttonStatus}
                                            onClick={() => this.backClick()}
                                            type="button"
                                            className="button-cancel" >Previous </Button>

                                        {/* <div className="activities" style={{ minHeight: "300px" }} >
                                            <br />
                                            {this.props.selectedDataById &&
                                                this.props.selectedDataById.practiceId &&
                                                this.props.selectedDataById.practiceId.metaDataSchema &&
                                                this.props.selectedDataById.practiceId.metaDataSchema.length !== 0 ?
                                                <span>
                                                    <Survey.Survey model={model} />

                                                </span> :
                                                <Loader active />
                                            }
                                        </div> */}
                                    </Grid.Column >
                                </Grid.Row>
                            </Grid >
                        </Grid.Row>
                        {/* {this.props.selectedDataById.status === 0 || this.props.selectedDataById.status === 4 ? */}
                        {/* <Grid.Row>
                            <Grid.Column width={8} className="pad_0">
                                <div className="bottom_button_set" >
                                    <Button
                                        disabled={this.props.buttonStatus}
                                        onClick={() => this.backClick()}
                                        type="button"
                                        className="button-cancel" >Previous </Button>
                                </div>
                            </Grid.Column >
                            <Grid.Column width={8} className="pad_0">
                                <div className="bottom_button_set" style={{ textAlign: "right" }} >
                                    {this.props.selectedDataById.status === 4 && <Button
                                        type="button"
                                        className="button-cancel"
                                        onClick={() => this.cancelEdit()}>Cancel </Button>}
                                    <Button
                                        disabled={!this.props.isDurationSet}
                                        type='submit'
                                        id='next'
                                        className="button-submit"
                                        onClick={() => this.next()} > Next </Button>
                                </div>
                            </Grid.Column >

                        </Grid.Row> */}
                        {/* : ""} */}
                    </Grid>
                </Form>
            </div>
        );
    }
}



export default withRouter(ServeyMetaDataForm);

